import React from 'react';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import { MONTHS } from 'constants/DateConstants';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row';
import Text from 'components/Text';
import { CardElement } from 'react-stripe-elements';
import EventTracking from 'lib/EventTracking';

type Props = {
  selectedChildName: string | null;
  onCardInputCompleted: () => void;
};

class PurchaseDescription extends React.Component<Props> {
  componentDidMount() {
    EventTracking.trackKey('coaching.payment.view');
  }

  /* return a date in the form August 1, 2019 */
  formatDate(d: Date): string {
    return `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
  }

  endOfTrial(): Date {
    const today = new Date();
    const endOfTrial = new Date();
    endOfTrial.setDate(today.getDate() + 7);
    return endOfTrial;
  }

  trialPeriod() {
    const today = new Date();
    return `${this.formatDate(today)} to ${this.formatDate(this.endOfTrial())}`;
  }

  chargeDate() {
    return `Charged on ${this.formatDate(this.endOfTrial())}, cancel or skip anytime.`;
  }

  render() {
    if (!this.props.selectedChildName) return null;
    return (
      <React.Fragment>
        <Row size="small">
          <Heading level="2">Review your details</Heading>
        </Row>
        <Row size="xsmall">
          <Text size="small">Student:</Text>
        </Row>
        <Row>
          <Text weight="semibold" size="medium">
            {this.props.selectedChildName}
          </Text>
        </Row>
        <Row>
          <Box size="large" textAlign="left">
            <BoxBody size="small">
              <MediaObject figure="right" gutter="xxxxxlarge">
                <Text weight="semibold" size="medium">
                  Free 7 day trial
                </Text>
                <Text weight="semibold" size="medium">
                  $0.00
                </Text>
              </MediaObject>
              <Text size="medium" color="thunder">
                {this.trialPeriod()}
              </Text>
            </BoxBody>
            <BoxFooter size="small" dark>
              <MediaObject figure="right" gutter="xxxxxlarge">
                <Text weight="semibold" size="medium">
                  Total due today
                </Text>
                <Text weight="semibold" size="medium">
                  FREE
                </Text>
              </MediaObject>
            </BoxFooter>
          </Box>
        </Row>
        <Row size="large">
          <Box size="large" textAlign="left">
            <BoxBody size="small">
              <Row size="xxsmall">
                <MediaObject figure="right">
                  <Text weight="semibold" size="medium">
                    Remind Coaching
                  </Text>
                  <Text weight="semibold" size="medium">
                    $40 / week
                  </Text>
                </MediaObject>
                <Text size="medium" color="thunder">
                  {this.chargeDate()}
                </Text>
              </Row>
            </BoxBody>
          </Box>
        </Row>
        <Row>
          <Heading level="5" divided>
            <Text color="thunder">BILLING DETAILS</Text>
          </Heading>
        </Row>
        <Row>
          <CardElement
            onFocus={() => EventTracking.trackKey('coaching.payment.enter_card.click')}
            onChange={(e: stripe.elements.ElementChangeResponse) => {
              if (e.complete && !e.error) {
                this.props.onCardInputCompleted();
              }
            }}
          />
        </Row>
        <Row>
          <Text color="thunder">
            By clicking “Submit,” you consent for your child to use Remind for Remind Coaching. Your
            card will be charged at the end of your 7-day trial and every week after that. You can
            cancel Remind Coaching at any time.{' '}
            <Link href={LinkConstants.COACHING_HELP} target="_blank">
              <Text weight="semibold">Learn more</Text>
            </Link>
          </Text>
        </Row>
      </React.Fragment>
    );
  }
}

export default PurchaseDescription;
